
import { Vue, Component, Prop } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";
import DocumentProvider from "@/components/documents/DocumentProvider.vue";
import TableViewIcon from "@/components/icons/TableViewIcon.vue";
import Processing from "@/components/common/Processing.vue";
import UiButton from "@/components/button/ui-button.vue";
import { Project_Activity } from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import moment from "moment";
import UPDATE_PROJECT_ACTIVITY from "@/apollo/projectActivities/UpdateActivity.gql";
import MessageIcon from "@/components/icons/MessageIcon.vue";
import Message from "@/data/notificationsMessages";
import { NOTIFICATION } from "@/entities/Events";

@Component({
  components: {
    DocumentProvider,
    TableViewIcon,
    Processing,
    UiButton,
    MessageIcon,
    S3Image,
  },
})
export default class suggestedResourceTable extends Vue {
  @Prop({ type: Array, required: true }) suitableContractors: { id: string }[];
  @Prop({ type: String, default: undefined }) readonly visitId?: string;

  contarctorJob(res): string {
    if (res.job_title && res.job_title.length > 1) {
      return res.job_title;
    } else {
      return "n/a";
    }
  }
  get defaultImageClasses() {
    return "text-storm-gray text-sm font-medium rounded-full border border-gray-300 bg-white h-[22px] w-5 mr-1";
  }
  get getAvatrClass() {
    return "chipHeight flex-shrink-0 circleWidth uppercase rounded-full bg-primary-500 flex items-center text-xs justify-center text-white";
  }

  async handleAssignClick(res): Promise<void> {
    const contractor_id = res.routeParams?.params?.id
      ? res.routeParams.params.id
      : null;
    const activity = {
      contractor_updated_at: moment(new Date()),
      contractor_id: contractor_id,
      accepted: null,
      rejected: null,
    };

    await this.updateBasicActivityData(this.visitId, activity);
    this.$emit("activityUpdated");
    this.closeModal();
    this.$eventBus.emit(
      NOTIFICATION,
      Message.successMessage("Resource assigned successfully.")
    );
  }

  contractorPageRoute(res) {
    return {
      name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
      params: {
        id: res.routeParams.params.id,
      },
    };
  }

  closeModal(): void {
    this.$emit("close");
  }

  updateBasicActivityData(id: string, activity: Partial<Project_Activity>) {
    return this.$apollo.mutate({
      mutation: UPDATE_PROJECT_ACTIVITY,
      variables: {
        id,
        set: activity,
      },
    });
  }
  openMessage(res): void {
    this.$router.push({
      name: "inbox",
      query: {
        recipientUserId: res.id,
      },
    });
  }
  getInitials(name) {
    const words = name.toString().split(" ");
    const initials = words.map((word) => word.charAt(0));
    const result = initials.join("");
    return result;
  }
}
